module.exports = __webpack_public_path__ + "static/media/splash-screen.6b8674b8.PNG";